<template>
    <div class="bascchreibung bg-fff">
        <div class="design">
            <div class="banner" v-if="!!detail.detailPagePicture">
                <img :src="imgBaseUrl+detail.detailPagePicture.key" alt="">
            </div>
            <div class="big-title" v-if="!!detail.bigTitle">{{detail.bigTitle}}</div>
            <div class="small-title" v-if="!!detail.smallTitle">{{detail.smallTitle}}</div>
            <div class="content" v-html="detail.content"></div>
            <div class="buttomShare">
               <product-share :shareTarget="shareTarget" :inspiration="1"></product-share>
            </div>
        </div>
        <div class="bottomButton" v-if="type === 1">
            <span @click="modal1 = true">我要报名</span>
        </div>
        <Modal
                v-model="modal1"
                title="填写报名信息">
            <div class="input">
                <p>姓名：
                    <input v-model="value1" placeholder="请输入姓名" style="width: 300px"/>
                    </p>
                <p style="margin-top: 30px;">电话：<input v-model="value2" placeholder="请输入电话"
                                                       style="width: 300px"/></p>
                <div class="inputButton">
                    <span @click="clickSure">确定</span>
                </div>
            </div>

        </Modal>
        <loading v-if="busy" style="margin-top:60px;padding-bottom:80px;"></loading>
    </div>
</template>
<style rel="stylesheet/scss" lang="scss">
    .bascchreibung {
        .design {
            width: 960px;
            margin: auto;
            .content {
                img {
                    width: 960px;
                    font-size: 0;
                    display: block;
                }
                p {
                    margin: 0;
                    font-size: 14px;
                    color: #000000;
                    line-height: 30px;
                }
            }
            .buttomShare{
                display: inline-block;
                margin: 30px 0;
                text-align: left;
                margin-bottom: 100px;
                margin-left: -10px;
            }
            .banner {
                > img {
                    width: 100%;
                    font-size: 0;
                    display: block;
                }
            }
            .big-title {
                margin-top: 30px;
                font-size: 20px;
                color: #555;
            }
            .small-title {
                margin-top: 5px;
                font-size: 16px;
                color: #999;
            }
            .content {
                padding-top: 30px;
            }
        }
    }
</style>
<script>
    import api from '../../../../../src/api'
    import loading from '../../../../../src/components/common/loading.vue'
    import productShare from '../../../../../src/components/common/product-share.vue'

    export default {
        data() {
            return {
                imgBaseUrl: api.common.imgBaseUrl,
                id: this.$route.params.id,
                type: parseInt(this.$route.params.type),
                detail: {},
                busy: false,
                modal1: false,
                value1: '',
                value2: '',
                shareTarget: 1
            }
        },
        props: {
            data: {
                type: Array
            }
        },
        methods: {
            desingerShow() {
                this.busy = true
                api.homePage.desingerShow(this.id)
                    .then(res => {
                        this.detail = res
                        this.busy = false
                    }, () => {
                        this.busy = false;
                    })
            },

            clickSure() {
                if (this.value1 != '' && this.value2 != '') {
                    let data = {
                        'userName': this.value1,
                        'mobilePhone': this.value2,
                        'activityId': this.type
                    }
                    api.homePage.activitySign(data)
                        .then(res => {
                            this.$Message.info('报名成功！');
                            this.modal1 = false
                        })
                } else {
                    this.$Message.error('不能为空！');
                }

            }
        },
        created() {
            this.desingerShow()
        },
        components: {
            loading,
            productShare
        }
    }
</script>

<style scoped>
    .bascchreibung {
        width: 100%;

    }

    .bascchreibung .bascc {
        display: inline-block;
        width: 100%;
        text-align: center;
        /*padding: 20px  0px;*/
    }

    .bascchreibung .changeBg {
        background: #F2F4F5;
    }

    .bascchreibung .bascc .title {
        display: inline-block;
        width: 100%;
        font-size: 54px;
        color: #353838;
    }

    .bascchreibung .bascc .img {
        display: inline-block;
        width: 1000px;
        text-align: center;
    }

    .bascchreibung .bascc .img img {
        display: inline-block;
    }

    .bottomButton {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 60px;
        line-height: 60px;
        padding: 0 50px;
        text-align: center;
        background: rgba(0, 0, 0, 0.2);
    }

    .bottomButton span {
        padding: 11px 25px;
        background: #E14B5D;
        border-radius: 5px;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
    }

    .input {
        padding: 30px 0 20px 0;
    }

    .input p {
        font-size: 14px;
    }

    .input .inputButton {
        width: 100%;
        height: 60px;
        line-height: 60px;
        margin-top: 15px;
        padding: 0 88px;
        text-align: right;
    }

    .input .inputButton span {
        padding: 10px 20px;
        background: #308697;
        border-radius: 5px;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
    }
</style>